import de, {langKey as deLangKey } from './translationFiles/de.js'
import en, {langKey as enLangKey} from './translationFiles/en.js'

export const set = (state, action) => {
    if(action.payload === 'EN') {
        return {...state, translation: en, currentLang: enLangKey}
    } else {
        return {...state, translation: de, currentLang: deLangKey}
    }
}